import Header from "../../../../components/common/header";

interface CouponPolicyArticle {
  title: string;
  items: string[];
}

const INTRO =
  "본 정책은 주식회사 마히(이하 “회사”)가 운영하는 마감히어로 서비스에서 제공하는 쿠폰의 발급 및 이용에 관한 사항을 정합니다.";

const ARTICLES: CouponPolicyArticle[] = [
  {
    title: "제1조 (쿠폰의 정의 및 발급)",
    items: [
      "“쿠폰”이란 회사가 회원가입, 친구초대, 구매, 스탬프, 리뷰, 이벤트, 프로모션, 제휴, 고객 보상 등의 목적으로 회원에게 제공하는 할인 혜택을 의미합니다.",
      "쿠폰은 회사가 직접 지급하거나 회원이 사전에 안내된 일정한 조건을 충족한 경우 지급될 수 있습니다.",
      "본 정책에 따른 쿠폰은 회원에게 별도로 판매되는 유상 상품권이 아니며, 현금으로 교환하거나 출금할 수 없습니다. 회사가 별도로 허용한 경우를 제외하고 다른 회원에게 양도할 수 없습니다.",
      "쿠폰별 할인금액, 발급 대상, 최소 주문금액, 적용 상품·매장·지역, 유효기간, 사용횟수 등 이용조건은 쿠폰의 종류 및 발급 목적에 따라 다르게 정할 수 있습니다.",
      "개별 쿠폰의 주요 이용조건은 쿠폰 발급 화면, 이벤트·프로모션·제휴 안내 또는 앱 내 [내 쿠폰함] 등을 통해 회원이 확인할 수 있도록 안내합니다.",
    ],
  },
  {
    title: "제2조 (쿠폰의 사용)",
    items: [
      "회원은 개별 쿠폰에 표시된 이용조건을 충족하는 경우 해당 쿠폰을 사용할 수 있습니다.",
      "별도의 안내가 없는 경우 하나의 주문에는 1개의 쿠폰만 사용할 수 있으며 여러 쿠폰을 합산하여 사용할 수 없습니다.",
      "쿠폰 할인금액이 쿠폰 적용 대상 주문금액을 초과하는 경우 남은 할인금액은 별도로 반환되지 않습니다.",
      "결제가 완료된 이후에는 해당 주문에 쿠폰을 추가로 적용하거나 적용한 쿠폰을 다른 쿠폰으로 변경할 수 없습니다.",
    ],
  },
  {
    title: "제3조 (쿠폰의 유효기간)",
    items: [
      "쿠폰에는 종류 및 발급 목적에 따라 유효기간이 설정될 수 있으며, 회사는 유효기간이 있는 경우 회원이 이를 확인할 수 있도록 표시합니다.",
      "유효기간이 경과한 쿠폰은 사용할 수 없으며 원칙적으로 유효기간 연장 또는 재발급되지 않습니다.",
      "다만, 회사 또는 판매자의 귀책사유, 서비스 장애 등 회원에게 책임이 없는 사유로 쿠폰을 정상적으로 사용할 수 없었던 경우에는 구체적인 상황을 고려하여 유효기간 연장, 쿠폰 재발급 또는 이에 상응하는 조치를 할 수 있습니다.",
    ],
  },
  {
    title: "제4조 (주문 취소 시 쿠폰의 처리)",
    items: [
      "쿠폰을 사용한 주문이 전액 취소되는 경우 사용한 쿠폰은 반환하는 것을 원칙으로 합니다.",
      "반환된 쿠폰에는 최초 발급 당시의 유효기간이 그대로 적용되며, 주문 취소를 이유로 유효기간이 새롭게 시작되거나 자동으로 연장되지 않습니다.",
      "회원의 사유로 주문이 취소되어 반환된 쿠폰이 기존 유효기간을 경과한 경우 해당 쿠폰은 만료되며 연장 또는 재발급되지 않습니다.",
      "다만, 회사 또는 판매자의 귀책사유로 주문이 취소되어 반환 당시 쿠폰이 이미 만료되었거나 정상적인 재사용이 어렵게 된 경우에는 유효기간 연장, 동일 또는 이에 상응하는 쿠폰의 재발급 등 합리적인 조치를 할 수 있습니다.",
    ],
  },
  {
    title: "제5조 (이벤트·프로모션 및 제휴 쿠폰)",
    items: [
      "회사는 일정 기간 동안 이벤트, 프로모션 또는 제휴를 통해 쿠폰을 제공할 수 있습니다.",
      "쿠폰 지급을 위하여 회원가입, 구매, 친구초대, 리뷰 작성, 스탬프 적립, 제휴 이벤트 참여 등 일정한 조건을 요구할 수 있으며, 회사는 해당 조건을 회원이 참여하기 전에 확인할 수 있도록 안내합니다.",
      "이벤트·프로모션 및 제휴 쿠폰의 발급기간, 사용기간, 발급 대상, 할인금액, 최소 주문금액, 적용 대상 및 사용횟수 등 주요 이용조건은 해당 이벤트 또는 쿠폰 발급 시 안내합니다.",
      "이벤트·프로모션 또는 제휴가 종료된 이후에는 새로운 쿠폰의 발급을 종료할 수 있습니다.",
      "이벤트·프로모션 또는 제휴가 종료되더라도 이미 발급된 쿠폰은 원칙적으로 발급 당시 안내된 유효기간 및 이용조건에 따라 사용할 수 있습니다.",
    ],
  },
  {
    title: "제6조 (쿠폰의 부정 취득 및 이용)",
    items: [
      "허위 또는 부정한 방법, 복수 계정의 부당한 이용, 허위 리뷰·친구초대·미션, 시스템 오류의 악용 등으로 쿠폰을 부정하게 취득하거나 사용한 사실이 객관적으로 확인된 경우 회사는 해당 쿠폰의 발급·사용을 제한하거나 회수할 수 있습니다.",
      "회사가 쿠폰의 사용을 제한하거나 회수하는 경우 그 사유를 회원에게 안내합니다.",
      "회사 또는 시스템의 오류 등 회원에게 책임이 없는 사유만으로 정상적으로 취득한 쿠폰의 이용을 부당하게 제한하지 않습니다.",
    ],
  },
  {
    title: "제7조 (정책의 변경 및 기타)",
    items: [
      "회사는 관련 법령의 범위 내에서 본 정책을 변경할 수 있으며, 변경 시 적용일자 및 주요 변경 내용을 서비스 내 공지 등의 방법으로 안내합니다.",
      "회원에게 불리하거나 권리·의무에 중대한 영향을 미치는 변경은 관련 법령 및 마감히어로 이용약관에서 정한 절차에 따라 사전에 안내합니다.",
      "정책 변경 전에 이미 발급된 쿠폰은 원칙적으로 발급 당시 안내된 이용조건에 따라 사용할 수 있습니다.",
      "본 정책에서 정하지 않은 사항은 마감히어로 이용약관 및 관련 법령에 따르며, 본 정책과 관련 법령이 상충하는 경우 관련 법령을 우선하여 적용합니다.",
    ],
  },
];

const CouponPolicy = () => {
  return (
    <div className="w-full h-[100vh] flex flex-col bg-white">
      <Header title="쿠폰 이용정책" showBackButton />

      <div className="flex-1 overflow-y-auto px-4 py-6 pb-12">
        <h1 className="text-xl font-semibold text-black">쿠폰 이용정책</h1>
        <p className="mt-4 text-sm leading-relaxed text-black">{INTRO}</p>

        {ARTICLES.map((article) => (
          <section key={article.title} className="mt-8">
            <h2 className="text-base font-semibold text-black">
              {article.title}
            </h2>
            <ol className="mt-3 space-y-3">
              {article.items.map((item, index) => (
                <li
                  key={`${article.title}-${index}`}
                  className="flex gap-2 text-sm leading-relaxed text-black"
                >
                  <span className="shrink-0">{index + 1}.</span>
                  <span>{item}</span>
                </li>
              ))}
            </ol>
          </section>
        ))}

        <section className="mt-8">
          <h3 className="text-base font-semibold text-black">부칙</h3>
          <ol className="mt-3 space-y-3">
            <li className="flex gap-2 text-sm leading-relaxed text-black">
              <span className="shrink-0">1.</span>
              <span>
                본 정책은{" "}
                <strong>2026년 8월 31일부터 시행합니다.</strong>
              </span>
            </li>
            <li className="flex gap-2 text-sm leading-relaxed text-black">
              <span className="shrink-0">2.</span>
              <span>
                본 정책 시행 전에 발급된 쿠폰은 해당 쿠폰 발급 당시 안내된
                이용조건을 적용합니다.
              </span>
            </li>
          </ol>
        </section>
      </div>
    </div>
  );
};

export default CouponPolicy;
